import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields"

import LBM from ".."

import TextInput from "components/form/input/TextInput"

export function LBMParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={LBM.field + tipoIndicadorField}
            tabFields={
                <>
                    <ParamFormRow label="Meta Brocas Internas">
                        <TextInput name="metaBrocasInternas" label="Quantidade" type="number" />
                    </ParamFormRow>
                    <ParamFormRow label="Meta - ( % Brocas)">
                        <TextInput name="meta" label="Meta (%)" type="number" />
                    </ParamFormRow>
                </>
            }
        />
    )
}
